import { Pipe, PipeTransform } from '@angular/core';
import { Amount } from '@qvs/core';
import { CurrencyService } from '~/shared/services/currency.service';
import { AmountHelper } from '~/shared/helpers/amount-helper';

@Pipe({
  name: 'amount',
  standalone: true
})
export class AmountPipe implements PipeTransform {
  constructor(private readonly currencyService?: CurrencyService) {}

  transform(
    amountOrNumber?: Amount | number | string,
    showCurrency = false,
    showNullDecimals = true,
    minusAmounts?: Amount[],
    showAsNegative = false,
    showConvertedCurrencyId?: string
  ): string {
    let convertedMinusAmount = 0;

    if (minusAmounts && this.currencyService && (amountOrNumber as Amount)?.currency) {
      minusAmounts.forEach((minusAmount) => {
        const amountInTargetCurrency = this.currencyService.conversion(minusAmount, (amountOrNumber as Amount).currency);
        convertedMinusAmount = convertedMinusAmount + amountInTargetCurrency.value;
      });
    }

    const result = AmountHelper.toString(
      amountOrNumber,
      showCurrency,
      showNullDecimals,
      convertedMinusAmount,
      showAsNegative,
      this.currencyService?.getCurrencyDecimals((amountOrNumber as any)?.currency)
    );

    if (showConvertedCurrencyId) {
      return `${result}<span class="amount-c-v">${this.currencyService.toConversionString(
        AmountHelper.calculateAmount(amountOrNumber),
        showConvertedCurrencyId
      )}</span>`;
    }

    return result;
  }
}
